<div class="video_player_container" [class.video_is_play]="isVideoPlaying">
  <div class="video_player_overlay">
    <button type="button" class="player_icon" (click)="toggleVideo()" *ngIf="!isVideoPlaying && currentTime == 0">
      <svg xmlns="http://www.w3.org/2000/svg" width="31.875" height="38.851" viewBox="0 0 31.875 38.851">
        <path id="Path_103376" data-name="Path 103376"
          d="M123.25-811.25l24.375-15.625a3.526,3.526,0,0,0,1.75-3.125,3.526,3.526,0,0,0-1.75-3.125L123.25-848.75a3.439,3.439,0,0,0-3.813-.187,3.525,3.525,0,0,0-1.937,3.313v31.25a3.525,3.525,0,0,0,1.937,3.313A3.439,3.439,0,0,0,123.25-811.25Z"
          transform="translate(-117.5 849.426)" />
      </svg>
    </button>
    <div class="video_controls" *ngIf="duration">
      <div #progressBar class="progress_bar_container" (click)="seekVideoTo($event,progressBar.offsetWidth)">
        <div class="progress-bar" [style.width.%]="progress"></div>
      </div>
      <div class="video_controls_wrapper">
        <div class="side_left_controls">
          <button type="button" class="btn_player" (click)="toggleVideo()">
            <svg *ngIf="isVideoPlaying" xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20">
              <path id="ic_pause"
                d="M253.333-740a2.485,2.485,0,0,1-1.883-.839,2.853,2.853,0,0,1-.783-2.018v-14.286a2.853,2.853,0,0,1,.783-2.018,2.485,2.485,0,0,1,1.883-.839,2.485,2.485,0,0,1,1.883.839,2.853,2.853,0,0,1,.783,2.018v14.286a2.853,2.853,0,0,1-.783,2.018A2.485,2.485,0,0,1,253.333-740Zm-10.667,0a2.485,2.485,0,0,1-1.883-.839,2.853,2.853,0,0,1-.783-2.018v-14.286a2.853,2.853,0,0,1,.783-2.018,2.485,2.485,0,0,1,1.883-.839,2.485,2.485,0,0,1,1.883.839,2.853,2.853,0,0,1,.783,2.018v14.286a2.853,2.853,0,0,1-.783,2.018A2.485,2.485,0,0,1,242.667-740Z"
                transform="translate(-240 760)" />
            </svg>
            <svg *ngIf="!isVideoPlaying" xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20">
              <path id="ic_play"
                d="M320-708.619v-16.761a1.552,1.552,0,0,1,.474-1.154A1.529,1.529,0,0,1,321.58-727a1.542,1.542,0,0,1,.415.061,1.626,1.626,0,0,1,.415.182l12.879,8.381a1.555,1.555,0,0,1,.533.607A1.732,1.732,0,0,1,336-717a1.732,1.732,0,0,1-.178.769,1.555,1.555,0,0,1-.533.607l-12.879,8.381a1.626,1.626,0,0,1-.415.182,1.542,1.542,0,0,1-.415.061,1.529,1.529,0,0,1-1.106-.466A1.552,1.552,0,0,1,320-708.619Z"
                transform="translate(-320 727)" />
            </svg>
          </button>
          <span class="video_time_duraion">
            {{ currentTime * 1000 | date:'H:mm:ss':'UTC'}}
            / {{ duration * 1000 | date:'H:mm:ss':'UTC'}}
          </span>
        </div>
      </div>
    </div>
  </div>
  <!-- <iframe #iframeRef [hidden]="!videoUrl" [src]="videoUrl" width="100%" allowfullscreen="true"
    webkitallowfullscreen="true" mozallowfullscreen="true" [ngClass]="{'video-iframe': true}" height="auto"
    frameborder="0"></iframe> -->
  <iframe #iframeRef width="100%" [src]="videoUrl" frameborder="0" allow="autoplay; fullscreen" allowfullscreen>
  </iframe>
</div>